<ng-container *ngIf="!userAgentService.isGoogleCrawler; else googleCrawlerSafeVideo">
    <app-sensitive-content-container
        *ngIf="isCautionFlagContainerDisplayed"
        [actionButtonName]="cautionFlagButtonName"
        [customClasses]="customClasses"
        [customAction]="true"
        (customActionTrigger)="playVideo()"
        class="content-flags-overlay"
    >
    </app-sensitive-content-container>
    <video
        id="pbslm-video-player"
        #player
        class="video-player video-js pbslm-skin vjs-big-play-centered vjs-16-9"
        crossorigin="anonymous"
        playsinline
        controls
    >
        <p class="vjs-no-js">
            To view this video please enable JavaScript, and consider upgrading to a web browser
            that
            <a
                href="https://videojs.com/html5-video-support/"
                target="_blank"
                rel="noopener noreferrer"
            >
                supports HTML5 video
            </a>
        </p>
    </video>
</ng-container>
<ng-template #googleCrawlerSafeVideo>
    <video
        class="crawler-safe-video"
        [poster]="video.getDefaultPosterImage()"
        [src]="crawlerSafeVideoSrc"
        controls
    ></video>
</ng-template>
